<div class="modal">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="detail" mat-dialog-content>
    <div class="txt">请根据您的需求选择</div>
    <div class="txt space">我们会为您提供合适的帮助</div>
    <div class="btn btn1" matRipple (click)="openPreSales1Modal()">
      我还没买
    </div>
    <div class="btn btn2" matRipple (click)="openAfterSales1Modal()">
      已经买了
    </div>
  </div>
</div>
